import { CellBoolean } from '../../table/cells/CellBoolean';
import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
export const ModelCellBooleanBase = (props: TableInheritedProps) => (
  <CellBoolean {...props} />
);

export const ModelCellBoolean = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellBoolean',
    ModelCellBooleanBase,
    props
  );
